import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import Pusher, { Options } from 'pusher-js';
import { ConnectionData, WebsocketConfig, WebsocketProvider } from '@capturum/websockets/core';
import { AuthService } from '@capturum/auth';

@Injectable({
  providedIn: 'root',
})
export class PusherWebsocketService implements WebsocketProvider {
  public config!: ConnectionData;
  private client!: Pusher;

  constructor(
    private websocketConfig: WebsocketConfig,
    private authService: AuthService,
  ) {
  }

  public setConfig(connectionData: ConnectionData): void {
    this.config = connectionData;
  }

  public initialize(): void {
    this.client = this.getPusherInstance(this.config.key, this.config as any);

    this.client.connection.bind("connected", () => {
      const socketId = this.client.connection.socket_id;
      this.websocketConfig.socketId = socketId;
    })
  }

  public disconnect(): void {
    this.client.disconnect();
  }

  public listenGlobal<T = any>(channel: string, privateChannel = false): Observable<T> {
    this.client.connect();
    const channelName = privateChannel ? `private-${channel}` : channel;
    let clientChannel = this.client.channels.find(channelName);

    if (!clientChannel) {
      clientChannel = this.client.subscribe(channelName);
    }

    clientChannel.unbind_global();

    return new Observable<T>((observer) => {
      clientChannel.bind_global((event: any, data: any) => {
        observer.next({ event, ...data });
      });
    });
  }

  public listenForEvent<T = any>(channel: string, event: string, privateChannel = false): Observable<T> {
    this.client.connect();
    const channelName = privateChannel ? `private-${channel}` : channel;
    let clientChannel = this.client.channels.find(channelName);

    if (!clientChannel) {
      clientChannel = this.client.subscribe(channelName);
    }

    clientChannel = clientChannel.unbind(event);

    return new Observable<T>((observer) => {
      clientChannel.bind(event, (data: T) => {
        observer.next(data);
      });
    });
  }

  private getPusherInstance(key: string, options: Options): Pusher {
    const token = this.authService.getToken();

    return new Pusher(key, {
      ...options,
      auth: {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      },
    });
  }
}
